import { render, staticRenderFns } from "./FamiliesEnrollmentDelete.vue?vue&type=template&id=77f3d5be&scoped=true"
import script from "./FamiliesEnrollmentDelete.vue?vue&type=script&lang=js"
export * from "./FamiliesEnrollmentDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f3d5be",
  null
  
)

export default component.exports